
export function loadLetter() {
    for(let letter of document.getElementsByClassName('letter')){
        letter.classList.add("is-loaded");

        const wrapper = letter.closest('.mainContent > *');
        if (wrapper) {
            wrapper.classList.add("letterWrapper")
        }
    }
}